import { useToken } from "@chakra-ui/react";
import { Global, css } from "@emotion/react";

export const DatePickerGlobalStyles = () => {
  const [
    smBorder,
    smPrimarySofter,
    smMuted,
    smText,
    smTealShadow,
    smPrimary,
    smPrimarySoft,
    smTextDisabled,
    grayDisabled,
  ] = useToken("colors", [
    "smBorder",
    "smPrimarySofter",
    "smMuted",
    "smText",
    "smTealShadow",
    "smPrimary",
    "smPrimarySoft",
    "smTextDisabled",
    "gray.300",
  ]);

  return (
    <Global
      styles={css`
        :is(#datepicker-portal, .themed-datepicker-inline) .react-datepicker-popper {
          z-index: 1400;
        }
        :is(#datepicker-portal, .themed-datepicker-inline) .react-datepicker {
          font-family: inherit;
          border: 1px solid ${smBorder};
          border-radius: 0.5rem;
          box-shadow:
            0 10px 15px -3px rgba(0, 0, 0, 0.1),
            0 4px 6px -2px rgba(0, 0, 0, 0.05);
          overflow: hidden;
        }
        :is(#datepicker-portal, .themed-datepicker-inline) .react-datepicker__header {
          background: ${smPrimarySofter};
          border-bottom: 1px solid ${smBorder};
          padding-top: 0.75rem;
        }
        /* When renderCustomHeader is provided, react-datepicker renders the day-names
           row OUTSIDE the calendar header (passed as dayNamesHeader to <Month>).
           So the calendar header's height = padding-top + DatePickerHeader's Flex
           (including its pb={2}) + padding-bottom. The time header reuses the same
           paddings via the .react-datepicker__header rule above; we match the Flex's
           pb={2} via margin-bottom on the "Tid" element below. */
        :is(#datepicker-portal, .themed-datepicker-inline) .react-datepicker__day-names {
          display: flex;
          justify-content: space-around;
        }
        :is(#datepicker-portal, .themed-datepicker-inline) .react-datepicker__day-name {
          color: ${smMuted};
          font-size: 0.75rem;
          font-weight: 500;
          width: 36px;
          line-height: 36px;
        }
        :is(#datepicker-portal, .themed-datepicker-inline) .react-datepicker__month {
          margin: 0.5rem;
        }
        :is(#datepicker-portal, .themed-datepicker-inline) .react-datepicker__week {
          display: flex;
          justify-content: space-around;
        }
        :is(#datepicker-portal, .themed-datepicker-inline) .react-datepicker__day {
          width: 36px;
          line-height: 36px;
          border-radius: 0.375rem;
          font-size: 0.875rem;
          color: ${smText};
          transition: all 0.1s;
        }
        :is(#datepicker-portal, .themed-datepicker-inline) .react-datepicker__day:hover {
          background: ${smTealShadow};
          border-radius: 0.375rem;
        }
        :is(#datepicker-portal, .themed-datepicker-inline) .react-datepicker__day--selected,
        :is(#datepicker-portal, .themed-datepicker-inline) .react-datepicker__day--keyboard-selected {
          background: ${smPrimary} !important;
          color: white !important;
          border-radius: 0.375rem;
          font-weight: 600;
        }
        :is(#datepicker-portal, .themed-datepicker-inline) .react-datepicker__day--selected:hover,
        :is(#datepicker-portal, .themed-datepicker-inline) .react-datepicker__day--keyboard-selected:hover {
          background: ${smPrimarySoft} !important;
        }
        :is(#datepicker-portal, .themed-datepicker-inline) .react-datepicker__day--today {
          font-weight: 700;
          color: ${smPrimary};
        }
        :is(#datepicker-portal, .themed-datepicker-inline) .react-datepicker__day--outside-month {
          color: ${smTextDisabled};
        }
        :is(#datepicker-portal, .themed-datepicker-inline) .react-datepicker__day--disabled {
          color: ${grayDisabled} !important;
          cursor: not-allowed;
        }
        :is(#datepicker-portal, .themed-datepicker-inline) .react-datepicker__day--disabled:hover {
          background: transparent !important;
        }
        :is(#datepicker-portal, .themed-datepicker-inline) .react-datepicker__triangle {
          display: none;
        }

        :is(#datepicker-portal, .themed-datepicker-inline) .react-datepicker__time-container {
          border-left: 1px solid ${smBorder};
        }
        :is(#datepicker-portal, .themed-datepicker-inline) .react-datepicker-time__header {
          /* Match the month/year Selects in DatePickerHeader (size="sm", fontWeight 600) */
          font-size: 0.875rem;
          font-weight: 600;
          color: ${smText};
          margin: 0;
          padding: 0;
          /* 2rem matches Chakra Select size="sm"; flex centers "Tid" within it
             so its baseline aligns with the month/year text on the left. */
          height: 2rem;
          display: flex;
          align-items: center;
          justify-content: center;
          /* Mirror DatePickerHeader's Flex pb={2} so the time header's total
             height matches the calendar's. */
          margin-bottom: 0.5rem;
        }
        :is(#datepicker-portal, .themed-datepicker-inline) .react-datepicker__time-list-item {
          font-size: 0.875rem;
          color: ${smText};
          transition: all 0.1s;
        }
        :is(#datepicker-portal, .themed-datepicker-inline) .react-datepicker__time-list-item:hover {
          background: ${smTealShadow} !important;
        }
        :is(#datepicker-portal, .themed-datepicker-inline) .react-datepicker__time-list-item--selected {
          background: ${smPrimary} !important;
          color: white !important;
          font-weight: 600;
        }
        :is(#datepicker-portal, .themed-datepicker-inline) .react-datepicker__time-list-item--selected:hover {
          background: ${smPrimarySoft} !important;
        }
      `}
    />
  );
};
